// (function(){
//     'use strict';
//     // !! With JCU-V1 Header redevelopment, JCU Pages not using the new platform require Header CSS/JS to be loaded
//     // !! To Prevent having users having load the entire JCU-V1 CSS/JS just for the header, these files are built in webpack.common.js again in a seperate legacy file.
//     // !! While users likely will Cache both Old JCU/JCU-V1 files anyway, Google Page Speed Insights scores are improved with this method, and thats how I get paid ¯\_(ツ)_/¯

//     // ? For Legacy support, if jcu_js_v1 is not defined, define again as _global/global.js is not within bundle
//     if(!jcu_js_v1) {
//         // Global variables
//         var jcu_js_v1 = {
//             'fn': {},
//             'vars': {}
//         };
//     }

//     jcu_js_v1.vars.isHome = false;

//     jcu_js_v1.fn.initHeader = function(){

//         var scrollHeight = 64;

//         // Set list of allowed web paths that allow shadow Home style, and add class to header
//         var allowedPathNames = ["/", "/_nocache", "/_recache"];
//         if (allowedPathNames.indexOf(window.location.pathname) >= 0) jcu_js_v1.vars.isHome = true;

//         // If page is the homepage run funcs...
//         if (jcu_js_v1.vars.isHome) {
//             document.body.classList.add("page-home");
//         }

//         // Detch page scroll position immediately before Intersect Observer/EventListener exists (page-top and page-home are applied in Design Customisation #1077776)
//         if(window.scrollY > scrollHeight) {
//             document.body.classList.remove("page-top");
//         } else {
//             document.body.classList.add("page-top");
//         }
        
//         // Intersection Observer (If supported)
//         if (
//             "IntersectionObserver" in window &&
//             "IntersectionObserverEntry" in window &&
//             "intersectionRatio" in window.IntersectionObserverEntry.prototype
//         ) {
//             let observer = new IntersectionObserver(entries => {
//                 if (entries[0].boundingClientRect.y < 0) {
//                     document.body.classList.remove("page-top");
//                 } else {
//                     document.body.classList.add("page-top");
//                 }
//             });
//             // Attach Observer to Skip links
//             observer.observe(document.querySelector("#page-top-hook"));
          
//           } else {
//             // Intersection Observer NOT Supported, use debounced scroll eventListener fallback
//             // (debounced) Add Continous event Listener to handle scroll during page visit
//             window.addEventListener("scroll", jcu_js_v1.fn.debounce(function(){
                
//                 if(!document.body.classList.contains("search-active")) { 
//                     if(window.scrollY > scrollHeight) {
//                         document.body.classList.remove("page-top");
//                     } else {
//                         document.body.classList.add("page-top");
//                     }   
//                 }
//             }, 66));

//           }
          


//         // Handle Header Popup Search/Mobile Menu
//         document.querySelector(".jcu-v1__nav__search__btn").addEventListener("click", function(){

//             if(document.body.classList.contains("page-top")) {
//                 document.body.classList.remove("page-top");
//             }
            
//             if(document.body.classList.contains("search-active")) {
//                 document.body.classList.remove("search-active");
    
//                 if(window.scrollY < scrollHeight) {
//                     document.body.classList.add("page-top");
//                 }
    
//             } else {
//                 document.body.classList.add("search-active");
//             }
    
//         });

//     };

//     jcu_js_v1.fn.initHeader();

// }());
